import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { blip } from "@/lib/sound";
import PublicLayout from "@/components/public/PublicLayout";
import BlockRenderer from "@/components/public/BlockRenderer";
import { ESShell, ESBlocks } from "@/components/public/ESBlockRenderer";
import { Eye } from "lucide-react";

export default function Preview() {
  const { id } = useParams();
  const [page, setPage] = useState(undefined);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get(`/preview/pages/${id}`).then((r) => setPage(r.data)).catch(() => setPage(null));
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, [id]);

  const banner = (
    <div dir="rtl" className="fixed top-0 left-0 right-0 z-[60] bg-[#4A5D4E] text-white text-center py-2 font-editor text-sm flex items-center justify-center gap-2">
      <Eye className="w-4 h-4" /> מצב תצוגה מקדימה — כך ייראה העמוד לאחר פרסום (טיוטה, לא פורסם)
    </div>
  );

  if (page === undefined) {
    return <>{banner}<div className="min-h-screen flex items-center justify-center bg-[#0B0B0B]"><div className="w-8 h-8 border-2 border-[#21E6D3]/40 border-t-[#21E6D3] rounded-full animate-spin" /></div></>;
  }
  if (!page) {
    return <>{banner}<div className="min-h-screen flex items-center justify-center"><p className="font-body text-[#555]">העמוד לא נמצא.</p></div></>;
  }

  const isES = (page.blocks || []).some((b) => b.type?.startsWith("es_"));
  if (isES) {
    return (
      <>{banner}<div className="pt-9"><ESShell blocks={page.blocks} settings={settings}><ESBlocks blocks={page.blocks} onHover={(f) => blip(f)} settings={settings} /></ESShell></div></>
    );
  }
  return (
    <>{banner}<div className="pt-9"><PublicLayout><BlockRenderer blocks={page.blocks} /></PublicLayout></div></>
  );
}
